import React, { useState } from "react";
import { filterByName, filterByNewIdea, filterByStatus } from "../slices/formularioSlice";
import { useDispatch } from "react-redux";


export default function Filters({setCurrenPage}) {
  const dispatch = useDispatch();

  const [name, setName] = useState("")

  const handleFilterByStatus = (e) => {
    const status = e.target.value;
    dispatch(filterByStatus(status));
    setCurrenPage(1)
  };

  const handleFilterByNewIdea = (e) => {
    const idea = e.target.value === "true";
    dispatch(filterByNewIdea(idea));
    setCurrenPage(1)
  };

  const handleChangeName = (e) => {
    const name = e.target.value;
    setName(name)
    dispatch(filterByName(name))
    setCurrenPage(1)
  }
   

  return (
    <div className="sm:flex gap-2 ">
      <div className="flex justify-center my-3  ">
        <select
          onChange={handleFilterByStatus}
          className="bg-background text-text rounded  w-[220px] "
        >
          <option value="" key="">
            Filtrar por estados
          </option>
          <option value="Prospect" key="">
            Prospectos
          </option>
          <option value="Approved" key="">
            Aceptados
          </option>
          <option value="Rejected" key="">
            Denegados
          </option>
        </select>
      </div>

      <div className="flex justify-center my-3">
        <select
          onChange={handleFilterByNewIdea}
          className="bg-background text-text rounded  w-[220px] "
        >
          <option value="" key="">
            Es nueva idea?
          </option>
          <option value="true" key="">
            Si
          </option>
          <option value="false" key="">
            No
          </option>
        </select>
      </div>

      <div className="flex justify-center my-3">
        <input className="bg-background text-text w-[220px] rounded" onChange={handleChangeName} value={name} type="text" placeholder="Buscar por nombre" />
      </div>
    </div>
  );
}
